<template>
  <hm-content title="数据实时报表">
    <div>
      <div class="box-online">
        <div class="title">
          实时概况
        </div>
      </div>
      <div class="data-item">
        <div class="left left-blue">
          <div class="hmicon icon-shujubaobiao2x-pay">
          </div>
          <p class="tit">支付概况</p>
        </div>
        <div class="right">
          <div class="ft">
            <div>支付金额（元）</div>
            <div class="ft-value">{{payStatic.payInfo ? payStatic.payInfo.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.payInfo ? payStatic.payInfo.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.payInfo ? payStatic.payInfo.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>支付人数</div>
            <div class="ft-value">{{payStatic.payMember ? payStatic.payMember.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.payMember ? payStatic.payMember.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.payMember ? payStatic.payMember.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>支付订单数</div>
            <div class="ft-value">{{payStatic.payOrder ? payStatic.payOrder.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.payOrder ? payStatic.payOrder.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.payOrder ? payStatic.payOrder.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>支付商品件数</div>
            <div class="ft-value">{{payStatic.payGoods ? payStatic.payGoods.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.payGoods ? payStatic.payGoods.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.payGoods ? payStatic.payGoods.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>客单价（元）</div>
            <div class="ft-value">{{payStatic.payAvg ? payStatic.payAvg.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.payAvg ? payStatic.payAvg.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.payAvg ? payStatic.payAvg.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>毛利额</div>
            <div class="ft-value">{{payStatic.grossProfit ? payStatic.grossProfit.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.grossProfit ? payStatic.grossProfit.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.grossProfit ? payStatic.grossProfit.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft ft-margin">
            <div>毛利率</div>
            <div class="ft-value">{{payStatic.grossMargin ? payStatic.grossMargin.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payStatic.grossMargin ? payStatic.grossMargin.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payStatic.grossMargin ? payStatic.grossMargin.percentage : "-"}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-item">
        <div class="left left-red">
          <div class="hmicon icon-shujubaobiao2x-trans">
          </div>
          <p class="tit">交易转化</p>
        </div>
        <div class="right right-color">
          <div class="ft">
            <div>下单人数</div>
            <div class="ft-value">{{payTransStatic.createOrder ? payTransStatic.createOrder.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.createOrder ? payTransStatic.createOrder.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.createOrder ? payTransStatic.createOrder.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>访客-下单转化率</div>
            <div class="ft-value">{{payTransStatic.visitTrans ? payTransStatic.visitTrans.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.visitTrans ? payTransStatic.visitTrans.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.visitTrans ? payTransStatic.visitTrans.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>下单-支付率转化</div>
            <div class="ft-value">{{payTransStatic.payTrans ? payTransStatic.payTrans.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.payTrans ? payTransStatic.payTrans.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.payTrans ? payTransStatic.payTrans.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>访问-支付转化率</div>
            <div class="ft-value">{{payTransStatic.visitPayTrans ? payTransStatic.visitPayTrans.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.visitPayTrans ? payTransStatic.visitPayTrans.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{payTransStatic.visitPayTrans ? payTransStatic.visitPayTrans.percentage : "-"}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-item">
        <div class="left left-orange">
          <div class="hmicon icon-shujubaobiao2x-goods">
          </div>
          <p class="tit">商品数据</p>
        </div>
        <div class="right right-color">
          <div class="ft">
            <div>商品访问占比（点击商品详情页面/访客总数）</div>
            <div class="ft-value">{{goodsStatic ? goodsStatic.num : 0/0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{goodsStatic ? goodsStatic.yesterdayNum : 0/0}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>在架商品数</div>
            <div class="ft-value">{{goodsNum.todayOnShelfGoodsNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{goodsNum.yesterdayOnShelfGoodsNum}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>动销商品数</div>
            <div class="ft-value">{{goodsNum.todaySaleGoodsNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{goodsNum.yesterdaySaleGoodsNum}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>无动销商品数</div>
            <div class="ft-value">{{goodsNum.todayNotSaleGoodsNum}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{goodsNum.yesterdayNotSaleGoodsNum}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="data-item">
        <div class="left left-purple">
          <div class="hmicon icon-shujubaobiao2x-dataflow">
          </div>
          <p class="tit">流量概况</p>
        </div>
        <div class="right">
          <div class="ft">
            <div>浏览量</div>
            <div class="ft-value">{{dataFlowStatic.view ? dataFlowStatic.view.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{dataFlowStatic.view ? dataFlowStatic.view.yesterdayNum : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{dataFlowStatic.view ? dataFlowStatic.view.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>访客数</div>
            <div class="ft-value">{{dataFlowStatic.viewMember ? dataFlowStatic.viewMember.num : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{dataFlowStatic.viewMember ? dataFlowStatic.viewMember.yesterdayNum : "0"}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{dataFlowStatic.viewMember ? dataFlowStatic.viewMember.percentage : "-"}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-item">
        <div class="left left-sky">
          <div class="hmicon icon-deal">
          </div>
          <p class="tit">新老客户成交概况</p>
        </div>
        <div class="right">
          <div class="ft">
            <div>新成交客户数</div>
            <div class="ft-value">{{newMemberDealNum.value ? newMemberDealNum.value : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{newMemberDealNum.yesterdayValue ? newMemberDealNum.yesterdayValue : 0}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{newMemberDealNum.percentage ? newMemberDealNum.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>新成交客户支付金额（元）</div>
            <div class="ft-value">{{newMemberDealPrice.value ? newMemberDealPrice.value : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{newMemberDealPrice.yesterdayValue ? newMemberDealPrice.yesterdayValue : "0"}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{newMemberDealPrice.percentage ? newMemberDealPrice.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>老成交客户数</div>
            <div class="ft-value">{{oldMemberDealNum.value ? oldMemberDealNum.value : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{oldMemberDealNum.yesterdayValue ? oldMemberDealNum.yesterdayValue : "0"}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{oldMemberDealNum.percentage ? oldMemberDealNum.percentage : "-"}}</div>
              </div>
            </div>
          </div>
          <div class="ft">
            <div>老成交客户支付金额（元）</div>
            <div class="ft-value">{{oldMemberDealPrice.value ? oldMemberDealPrice.value : 0}}</div>
            <div class="flex ft-item">
              <div class="ft-item-margin">
                <div>昨日全天</div>
                <div class="ft-item-value">{{oldMemberDealPrice.yesterdayValue ? oldMemberDealPrice.yesterdayValue : "0"}}</div>
              </div>
              <div>
                <div>占昨日全天</div>
                <div class="ft-item-value">{{oldMemberDealPrice.percentage ? oldMemberDealPrice.percentage : "-"}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="overview-box">
        <div class="title">
          实时商品榜
        </div>
      </div>
      <div class="flex flex-center mt20">
        <div class="table flex-1 mr20">
          <div class="table-panel flex flex-between mt20">
            <div class="flex item-center">
              TOP10商品访客数
            </div>
          </div>
          <el-table stripe border :data="topGoodsVisit" size="small">
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="排名"
                width="50"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="visitCount"
                label="访客数"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="table flex-1 mr20">
          <div class="table-panel flex flex-between mt20">
            <div class="flex item-center">
              TOP10商品支付金额
            </div>
          </div>
          <el-table stripe border :data="topGoodsPay" size="small">
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="排名"
                width="50"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="payMoney"
                label="支付金额"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="table flex-1">
          <div class="table-panel flex flex-between mt20">
            <div class="flex item-center">
              TOP10商品毛利额
            </div>
          </div>
          <el-table stripe border :data="topGoodsGross" size="small">
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="排名"
                width="50"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="gross"
                label="毛利额"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="flex flex-center mt20">
        <div class="table flex-1 mr20">
          <div class="table-panel flex flex-between mt20">
            <div class="flex item-center">
              TOP10退款商品
            </div>
          </div>
          <el-table stripe border :data="topGoodsRefund" size="small">
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="排名"
                width="50"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="refundMoney"
                label="退款额"
            ></el-table-column>
          </el-table>
        </div>
        <div class="table flex-1 mr20">
          <div class="table-panel flex flex-between mt20">
            <div class="flex item-center">
              TOP10分销商品
            </div>
          </div>
          <el-table stripe border :data="topGoodsDistribution" size="small">
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="排名"
                width="50"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="saleNum"
                label="销售数量"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="saleMoney"
                label="销售额"
            ></el-table-column>
          </el-table>
        </div>
        <div class="table flex-1">
        <div class="table-panel flex flex-between mt20">
          <div class="flex item-center">
            TOP10分销员交易排行
          </div>
        </div>
        <el-table stripe border :data="topGoodsDistributionMember" size="small">
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="排名"
              width="50"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="销售名称"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="saleNum"
              label="销售数量"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="saleMoney"
              label="成交额"
          ></el-table-column>
        </el-table>
      </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
export default {
  data() {
    return {
      //支付概况
      payStatic: {},
      //交易转化
      payTransStatic: {},
      //商品数据
      goodsStatic: {},
      //流量概况
      dataFlowStatic: {},
      //TOP10商品访客数
      topGoodsVisit:[],
      //TOP10商品支付金额
      topGoodsPay:[],
      //TOP10商品毛利额
      topGoodsGross:[],
      //TOP10退款商品
      topGoodsRefund:[],
      //TOP10分销商品
      topGoodsDistribution: [],
      //TOP10分销员交易排行
      topGoodsDistributionMember:[],
      //新成交客户数
      newMemberDealNum: {},
      //新成交客户支付金额
      newMemberDealPrice: {},
      //老成交客户数
      oldMemberDealNum: {},
      //老成交客户支付金额
      oldMemberDealPrice: {},
      //在架商品数,动销商品数,无动销商品数
      goodsNum: {},
    }
  },
  created() {
    this.query();
  },
  mounted() {
  },
  methods: {
    async query() {
      let params = {
        storeCode: getLoginUser().storeCode
      };
      const {code, result} = await this.$store.dispatch("onlineReportQuery", params);
      if (code === '0') {
        this.payStatic = result.payStatic;
        console.log(this.payStatic)
        if (result.payTransStatic) {
          this.payTransStatic = result.payTransStatic;
        } else {
          this.payTransStatic = {};
        }
        if (result.goodsStatic) {
          this.goodsStatic = result.goodsStatic;
        } else {
          this.goodsStatic = {};
        }
        if (result.dataFlowStatic) {
          this.dataFlowStatic = result.dataFlowStatic;
        } else {
          this.dataFlowStatic = {};
        }
        if (result.newMemberDealNum) {
          this.newMemberDealNum = result.newMemberDealNum;
        }
        if (result.newMemberDealPrice) {
          this.newMemberDealPrice = result.newMemberDealPrice;
        }
        if (result.oldMemberDealNum) {
          this.oldMemberDealNum = result.oldMemberDealNum;
        }
        if (result.oldMemberDealPrice) {
          this.oldMemberDealPrice = result.oldMemberDealPrice;
        }
        if (result.goodsNum){
          this.goodsNum = result.goodsNum;
        }
        this.topGoodsVisit = result.topGoodsVisit;
        this.topGoodsPay = result.topGoodsPay;
        this.topGoodsGross = result.topGoodsGross;
        this.topGoodsRefund = result.topGoodsRefund;
        this.topGoodsDistribution = result.topGoodsDistribution;
        this.topGoodsDistributionMember = result.topGoodsDistributionMember;
      }
      console.log(result);

    }
  },
}
</script>

<style lang="scss" scoped>
.data-item {
  margin-bottom: 10px;
}
.left {
  width: 88px;
  height: 142px;
  float: left;
  .hmicon {
    font-size: 40px;
    text-align: center;
    padding-top: 40px;
    color: rgba(255, 255, 255, 1);
  }
  .tit {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    padding-top: 5px;
    text-align: center;

  }
}
.left-blue {
  background: #547DFF;
}
.left-red {
  background: #F65E6A;
}
.left-orange {
  background: #F78752;
}
.left-purple{
  background: #BF6DFF;
}
.left-sky{
  background: #56B0FF;
}
.left-sky_blue {
  background: #56B0FF;
}
.right {
  width: 1580px;
  height: 142px;
  background: #F8FAFF;
  margin-left: 88px;
}
.right-color {
  background: #FFF9F9;
}
.box-online {
  background: #ffffff;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
  }
}
.ft {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 20px;
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 50px;
  display: inline-block;
  .ft-value {
    font-size: 24px;
    font-weight: 600;
    line-height: 33px;
    margin-top: 5px;
  }
  .ft-item {
    margin-top: 5px;
    color: #ABACAD;
    .ft-item-margin {
      margin-right: 23px;
    }
    .ft-item-value {
      color: #3E3E3F;
      margin-top: 5px;
    }
  }
}
.ft-margin {
  margin-right: 0;
}
</style>